import { createComponent } from '@carvana/merch-components';
import { EpicSection } from '@/vdp/styles';

export const Section = createComponent(EpicSection, {
  className: 'flex flex-col items-center justify-center'
});

export const SectionContent = createComponent('div', {
  className:
    'mx-24 mt-32 grid grid-cols-1 gap-16 m:mx-0 m:grid-cols-[repeat(auto-fit,minmax(370px,1fr))]'
});

export const Card = createComponent('div', {
  className:
    'mx-auto flex w-full flex-1 flex-col gap-16 self-stretch overflow-hidden rounded-[6px] border border-grey-2 bg-white p-24 first:last:max-w-[564px] m:p-32'
});

export const MiddleWrapper = createComponent('div', {
  className: 'flex flex-col gap-16'
});

export const PillWrapper = createComponent('div', {
  className: 'flex flex-col gap-8 text-blue-6'
});

export const KBBPill = createComponent('div', {
  className:
    'flex justify-between rounded-r-full bg-grey-1 px-16 py-12 tl-body-s'
});

export const CleanVehicleTaxPill = createComponent('div', {
  className:
    'w-fit rounded-full bg-decorative-ev px-8 py-[2px] text-blue-6 tl-header-xs'
});

export const CarvnaPill = createComponent('div', {
  className:
    'flex w-3/4 items-center justify-between rounded-r-full bg-grey-2 px-16 py-12 tl-header-xs'
});

export const Text = createComponent('div', {
  className: 'text-grey-5 tl-body-s m:tl-body-m'
});

export const Reduction = createComponent('div', {
  className: 'flex gap-4 rounded bg-grey-1 px-8 py-[2px] text-blue-7 tl-body-s'
});

export const Bold = createComponent('span', { className: 'font-bold' });
